import useDataFetching from "hooks/useDataFetching";
import { formatDate } from "utils";
import { config } from "variables/config";
import MuiTable from "components/MuiTable";
import MButton from "components/Mbutton";
import { useNavigate } from "react-router-dom";
import AddMission from "./AddMission";
import { useDisclosure } from "@chakra-ui/hooks";
import AddMissionEnterprise from "./AddMissionEnterprise";
import { useState } from "react";
import { BsList, BsPlusCircle } from "react-icons/bs";
import PreloaderSpinner from "components/PreloaderSpinner"; // Garder si utilisé ailleurs, sinon peut être retiré
import { useTranslation } from "react-i18next"; // Importer useTranslation
import { getMissionHeader } from "Constaints"; // Importer la fonction traduite

export default function Missions() {
    const navigate = useNavigate();
    const { t } = useTranslation("missions_list"); // Utiliser le namespace 'missionsList'
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [open, setOpen] = useState(false);

    const [loading, errorE, missions, fetchMissions] = useDataFetching(
        `${config.app.api_url}/missions`
    );

    const [selectedMission, setselectedMission] = useState(null);

    const handleClick = (item) => {
        setselectedMission(item);
    };

    function createData(N, description, start, end, region, actions) {
        return {
            N, description, start, end, region, actions
        };
    }

    const rows = missions?.data?.sort((a, b) => new Date(b?.start) > new Date(a?.start) ? -1 : 1)?.map((item, index) => {
        return {
            handleClick: () => handleClick(item),
            datas: createData(
                index + 1,
                item?.description,
                formatDate(item.start),
                formatDate(item?.end),
                item?.region?.name,
                <div className="flex flex-col gap-2">
                    <MButton
                        onClick={() => navigate("/admin/enterprises", { state: { mission: item } })}
                    >
                        <BsList/>
                        {t("enterprise_list")} {/* Traduit */}
                    </MButton>
                    <MButton
                        onClick={() => { setselectedMission(item); setOpen(true); }}
                    >
                        <BsPlusCircle/>
                        {t("assign_enterprise")} {/* Traduit */}
                    </MButton>
                </div>
            ),
            history: item?.participants ? {
                title: t("participants_list"), // Traduit
                header: [
                    "#",
                    t("full_name"), // Traduit
                ],
                datas: item?.participants?.sort((a, b) => b - a)?.map((c, index) => {
                    return {
                        index: index + 1,
                        salary: c,
                    };
                })
            }
                : []
        };
    });

    return (
        <>
            <div className="flex justify-end my-2">
                <MButton variant={"primary"} onClick={() => { onOpen(); }} >
                    <BsPlusCircle/> {t("create_mission")} {/* Traduit */}
                </MButton>
            </div>
            <MuiTable
                loading={loading}
                hidePagiation={true}
                columns={getMissionHeader(t)}
                rows={rows}
                textEmpty={t("no_missions")} /> {/* Traduit */}
            <AddMission endFetch={fetchMissions} isOpen={isOpen} onClose={onClose} />
            <AddMissionEnterprise endFetch={fetchMissions} mission={selectedMission} isOpen={open} onClose={() => setOpen(false)} />
        </>
    );
}